
export function selectHierarchical() {
  return {
    restrict: 'E',
    template: require('./select-hierarchical.directive.html'),
    scope: {
      model: '=',
      items: '=', // [{label: 'facebook', subitems: [{id: 1, label: 'public'}, {id: 2, label: 'private'}]}]
      optional: '<?',
      label: '@?',
      placeholder: '@?',
      readonly: '<?',
    },
    controller: controller
  };
}

controller.$inject = ['$element', '$scope'];
function controller($element, $scope) {


  init();


  function init() {

    // Work around ng-ifs and ng-repeats creating child scopes 
    // (see e.g. https://stackoverflow.com/questions/18342917/angularjs-ng-model-doesnt-work-inside-ng-if )
    $scope.$watch("model", newModel => $scope.directiveModel = { 'value': newModel });

    // But in addition we need to forward any new value up to our parent scope 
    // (angular watches $scope.model because we declared it with '=' in the directive definition)
    $scope.$watch("directiveModel.value", newValue => $scope.model = newValue);
  }
}

